import React, { useEffect, useState } from 'react';
import CategoryRow from './CategoryRow'; 
import DedicatedPlayerView from './DedicatedPlayerView'; 
import DetailsHero from './details/DetailsHero';
import ReviewChat from './details/ReviewChat';
import { supabase } from './../../../supabaseClient';

interface Video {
  id: string;
  title: string;
  thumbnail: string;
  sinpose?: string;
  description?: string;
  category?: string;
  url?: string;        
  video_url?: string;   
  trailer_url?: string; 
  embed_id?: string;        
  full_video_id?: string;   
  is_short?: boolean;
  is_premium?: boolean;
  comments_count?: number;
  [key: string]: any; 
}

interface VideoDetailViewProps {
  video: Video;
  allVideos: Video[]; 
  onBack: () => void;
  onSelectVideo: (id: string) => void; 
}

export default function VideoDetailView({ video, allVideos, onBack, onSelectVideo }: VideoDetailViewProps) {
  const [dedicatedMode, setDedicatedMode] = useState<'movie' | 'trailer' | null>(null);
  const [commentCount, setCommentCount] = useState<number>(video.comments_count || 0);

  // 🚀 BUSCA DIRETA AO SUPABASE (Ignora o limite de 1000 shorts)
 // 🚀 BUSCA DIRETA AO SUPABASE (Busca inteligente por categoria)
  const [dbRelatedVideos, setDbRelatedVideos] = useState<any[]>([]);

  useEffect(() => {
    async function buscarDireto() {
      if (!video || !video.id) return;
      
      const catLower = (video.category || '').toLowerCase();
      const isGame = catLower.includes('game') || catLower.includes('jogo');

      try {
        // 1. 🎯 Tenta buscar primeiro os vídeos da CATEGORIA EXATA
        let { data: exactData } = await supabase
          .from('videos')
          .select('*')
          .neq('id', video.id)
          .not('is_short', 'eq', true)
          .not('post_type', 'eq', 'shorts')
          .eq('category', video.category) // O Segredo: Exige a mesma categoria!
          .order('created_at', { ascending: false })
          .limit(10);

        let finalVideos = exactData || [];

        // 2. 🛡️ O Tapa-Buracos Seguro: Se não houver 10 vídeos dessa categoria, preenche com a mesma família (sem misturar)
        if (finalVideos.length < 10) {
          const excludeIds = [video.id, ...finalVideos.map(v => v.id)];
          
          let fallbackQuery = supabase
            .from('videos')
            .select('*')
            // Ignora os vídeos que já encontrámos para não repetir
            .not('id', 'in', `(${excludeIds.join(',')})`)
            .not('is_short', 'eq', true)
            .not('post_type', 'eq', 'shorts')
            .limit(10 - finalVideos.length);

          // A regra de ferro: se for jogo, só busca jogos. Se for filme, só busca filmes.
          if (isGame) {
            fallbackQuery = fallbackQuery.or('category.ilike.%game%,category.ilike.%jogo%');
          } else {
            fallbackQuery = fallbackQuery.not('category', 'ilike', '%game%').not('category', 'ilike', '%jogo%');
          }

          const { data: fallbackData } = await fallbackQuery.order('created_at', { ascending: false });
          
          if (fallbackData) {
            finalVideos = [...finalVideos, ...fallbackData];
          }
        }

        setDbRelatedVideos(finalVideos);
      } catch (err) {
        console.error("Erro na busca direta:", err);
      }
    }
    buscarDireto();
  }, [video]);
  // Variáveis para análise de texto
 // Variáveis para análise de texto
  const categoryLower = (video.category || '').toLowerCase();
  const titleLower = (video.title || '').toLowerCase();
  
  // 🛡️ FILTRO CIRÚRGICO 1: Removemos Shorts e o próprio vídeo atual
  const cleanVideos = allVideos.filter(v => 
    v.id !== video.id && 
    !v.is_short && 
    v.post_type !== 'shorts' && 
    !(v.category || '').toLowerCase().includes('shorts')
  );

  // 🧠 FILTRO INTELIGENTE E ESTRITO DE RELACIONADOS
  // 1. Puxa APENAS a mesma categoria exata (ex: se for "Filmes: Ação", só puxa "Filmes: Ação")
  // 🧠 FILTRO INTELIGENTE E ESTRITO DE RELACIONADOS
  const isCurrentTrailer = categoryLower.includes('trailer') || titleLower.includes('trailer');

  // 1. Puxa APENAS a mesma categoria exata
  let relatedVideos = cleanVideos.filter(v => v.category === video.category);

  // 2. Lógica Dinâmica de Trailers:
  // Se o vídeo atual for um trailer, exige recomendações de trailers. 
  // Se for filme, bloqueia os trailers para não sujar a prateleira.
  relatedVideos = relatedVideos.filter(v => {
    const vTitle = (v.title || '').toLowerCase();
    const vCat = (v.category || '').toLowerCase();
    const isVTrailer = vTitle.includes('trailer') || vCat.includes('trailer');
    
    return isCurrentTrailer ? isVTrailer : !isVTrailer;
  });

  // 3. Fallback inteligente: Só ativa se houver menos de 5 vídeos.
 // 1. Tenta buscar da mesma família se faltarem vídeos
  if (relatedVideos.length < 15) {
    const otherSameFamily = cleanVideos.filter(v => {
      const vCat = (v.category || '').toLowerCase();
      const vTitle = (v.title || '').toLowerCase();
      
      const isSameFamily = categoryLower.includes('game') || categoryLower.includes('jogo')
        ? vCat.includes('game') || vCat.includes('jogo')
        : vCat.includes('filme');
      
      const isTrailer = vTitle.includes('trailer') || vCat.includes('trailer');
      const respectsTrailerRule = isCurrentTrailer ? isTrailer : !isTrailer;
      
      return isSameFamily && respectsTrailerRule && v.category !== video.category;
    });
    
    relatedVideos = [...relatedVideos, ...otherSameFamily];
  }

  // 2. 🚀 GARANTE SEMPRE 10 VÍDEOS: Se ainda assim faltarem, preenche com qualquer vídeo do site para não ficar vazio
  if (relatedVideos.length < 10) {
    const existingIds = new Set([video.id, ...relatedVideos.map(v => v.id)]);
    const fillers = cleanVideos.filter(v => !existingIds.has(v.id));
    relatedVideos = [...relatedVideos, ...fillers];
  }

  // Corta estritamente nos 10 primeiros resultados para a prateleira
  relatedVideos = relatedVideos.slice(0, 10);

  // 🛡️ A CARTADA MÁGICA: Se o banco de dados já nos trouxe os vídeos perfeitos da categoria, substitui a lista defeituosa pelos dele!
  if (dbRelatedVideos && dbRelatedVideos.length > 0) {
    relatedVideos = dbRelatedVideos;
  }

  const hasRealFullMovie = Boolean(video.full_video_id || video.video_url || video.link_video_curto);
  
  const isStandaloneContent = Boolean(
    video.is_short ||
    categoryLower.includes('curiosidades') ||
    categoryLower.includes('podcast') ||
    categoryLower.includes('shorts') ||
    categoryLower.includes('trailer') ||
    titleLower.includes('curiosidades') ||
    !hasRealFullMovie
  );

  const primaryLink = isStandaloneContent 
    ? (video.embed_id || video.url || video.full_video_id || '')
    : (video.full_video_id || video.video_url || video.url || '');

  const trailerLink = video.embed_id || video.trailer_url || '';

  if (dedicatedMode === 'movie') {
    return (
      <DedicatedPlayerView 
        key={video.id} // 👈 ADICIONE ESTA LINHA AQUI
        video={video}
        videoToPlayUrl={primaryLink}
        playerTitle={isStandaloneContent ? "Assistir Vídeo" : "Filme Completo"}
        allVideos={allVideos}
        onBackToDetails={() => setDedicatedMode(null)}
        onSelectVideo={onSelectVideo}
      />
    );
  }

  if (dedicatedMode === 'trailer') {
    return (
      <DedicatedPlayerView 
        key={video.id} // 👈 ADICIONE ESTA LINHA AQUI
        video={video}
        videoToPlayUrl={trailerLink}
        playerTitle="Trailer Oficial"
        allVideos={allVideos}
        onBackToDetails={() => setDedicatedMode(null)}
        onSelectVideo={onSelectVideo}
      />
    );
  }

  const videoWithUpdatedComments = {
    ...video,
    comments_count: commentCount
  };

  return (
    /* 🚀 GARANTE FUNDO PRETO E SEM SOBRAS BRANCAS NO RODAPÉ */
    <div key={video.id} style={{ backgroundColor: '#000000', color: '#fff', minHeight: '100vh', width: '100%', overflowX: 'hidden', fontFamily: 'system-ui, sans-serif', paddingBottom: '50px' }}>
      
      <DetailsHero 
        video={videoWithUpdatedComments}
        isStandaloneContent={isStandaloneContent}
        primaryLink={primaryLink}
        trailerLink={trailerLink}
        onBack={onBack}
        onPlayMovie={() => setDedicatedMode('movie')}
        onPlayTrailer={() => setDedicatedMode('trailer')}
      />

      {/* 🚀 Prateleira puxada para cima e com margem reduzida */}
      {relatedVideos.length > 0 && (
        <div style={{ marginTop: '-5px' }}>
          <CategoryRow 
            title="Você também pode curtir" 
            videos={relatedVideos} 
            onSelectVideo={onSelectVideo} 
          />
        </div>
      )}

      <ReviewChat 
        videoId={video.id} 
        onCommentAdded={(newTotal) => setCommentCount(newTotal)} 
      />

    </div>
  );
}